/**
 * @generated SignedSource<<b8f74e57740533e8ec67f1e01ae1852f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Role = "ADMIN" | "APPROVER" | "EDITOR" | "%future added value";
export type AdminUpdateUserRequest = {
  accountId?: string | null;
  accountRoles?: ReadonlyArray<Role> | null;
  brandAccess?: ReadonlyArray<AdminBrandAccessInput> | null;
  email?: string | null;
  featureFlagIds?: ReadonlyArray<string> | null;
  firstName?: string | null;
  fullName?: string | null;
  id: string;
  lastName?: string | null;
  superuser?: boolean | null;
};
export type AdminBrandAccessInput = {
  brandId: string;
  roles: ReadonlyArray<Role>;
};
export type UserFormDialogUpdateMutation$variables = {
  input: AdminUpdateUserRequest;
};
export type UserFormDialogUpdateMutation$data = {
  readonly updateUser: {
    readonly id: string;
  };
};
export type UserFormDialogUpdateMutation = {
  response: UserFormDialogUpdateMutation$data;
  variables: UserFormDialogUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminUser",
    "kind": "LinkedField",
    "name": "updateUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserFormDialogUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserFormDialogUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4e5f72c5a242afa27ff4a2a3825c7d81",
    "id": null,
    "metadata": {},
    "name": "UserFormDialogUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation UserFormDialogUpdateMutation(\n  $input: AdminUpdateUserRequest!\n) {\n  updateUser(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a55f21cebd1779bd9a8c22fa9cc08ff";

export default node;
